// i18n cho component SyncStatus dùng chung (badge "đồng bộ X phút trước" + nút).
const fragment = {
  vi: {
    'sync.syncedAgo': 'Đồng bộ {ago}',
    'sync.button': 'Đồng bộ',
  },
  en: {
    'sync.syncedAgo': 'Synced {ago}',
    'sync.button': 'Sync',
  },
};

export default fragment;
